import { useEffect, useState } from 'react';
import { getCustomViewSubject } from '../../../store/User';
import { CustomViewType } from './helpers';
import { isProjectScopedType, parseProjectScopedViewName } from './viewKey';

export interface View {
  name: string;
  isEdit: boolean;
}

export const useSavedViews = (type: CustomViewType, projectId?: string) => {
  const [views, setViews] = useState<View[]>([]);

  // Keyed on type: the Projects page keeps one modal mounted and flips its type on the inventory
  // toggle, so the filter has to re-bind or it keeps listing the previous mode's views.
  useEffect(() => {
    const viewSub = getCustomViewSubject().subscribe((views) => {
      setViews(
        views
          .filter((v) => v.page.startsWith(type))
          // Only related-inventory views are per-project: a project card shows just its own project's
          // views, every other related surface just account-wide ones. Other view types have no scope
          // in the name, so they are never filtered this way.
          .filter((v) => {
            if (!isProjectScopedType(type)) return true;
            const parsed = parseProjectScopedViewName(v.name);
            return projectId ? parsed?.projectId === projectId : parsed === null;
          })
          .map((v) => ({ name: v.name, isEdit: false }))
      );
    });
    return () => {
      if (viewSub) viewSub.unsubscribe();
    };
  }, [type, projectId]);

  return [views, setViews] as const;
};
